export class User {
    username: string;
    displayName: string;
}